import { createRef } from "react";

const state = {
  sections: 2,
  pages: 1,
  zoom: 1,
  top: createRef(),
};

export default state;
